/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsVignetteDuplicateCancellationTemplateData } from '../../models/mail-params-vignette-duplicate-cancellation-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendDuplicateVignetteMail$Params {
      body: MailParamsVignetteDuplicateCancellationTemplateData
}

export function sendDuplicateVignetteMail(http: HttpClient, rootUrl: string, params: SendDuplicateVignetteMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendDuplicateVignetteMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendDuplicateVignetteMail.PATH = '/sendMail/vignette-duplicate-cancellation';
